import React from 'react';
import { ProgressBarStyled } from './styles/ProgressBarStyled';
var ProgressBar = function ProgressBar(_ref) {
  var lapse = _ref.lapse,
    className = _ref.className;
  return React.createElement(ProgressBarStyled, {
    lapse: lapse,
    className: className
  });
};
export default ProgressBar;